import 'css-chunk:src/cms/editorialCard/editorialCard.module.scss';export default {
  "heading-xxl": "editorialCard-module__heading-xxl___SiUxz",
  "wrapper": "editorialCard-module__wrapper___vTNrf",
  "heading-xl": "editorialCard-module__heading-xl___2fcPX",
  "heading-lg": "editorialCard-module__heading-lg___wK57A",
  "heading-md": "editorialCard-module__heading-md___N7fmZ",
  "heading-sm": "editorialCard-module__heading-sm___Mgj39",
  "heading-xs": "editorialCard-module__heading-xs___P9ZXo",
  "body-one": "editorialCard-module__body-one___bvqYu",
  "body-two": "editorialCard-module__body-two___4VU4U",
  "body-three": "editorialCard-module__body-three___w7hBb",
  "body-four": "editorialCard-module__body-four___ORV9i",
  "overline-one": "editorialCard-module__overline-one___zufhG",
  "overline-two": "editorialCard-module__overline-two___HtKVw",
  "overline-three": "editorialCard-module__overline-three___5OsUq",
  "strong": "editorialCard-module__strong___ffSf-",
  "em": "editorialCard-module__em___NFyN6",
  "figcaption": "editorialCard-module__figcaption___fuAVz",
  "no-margin": "editorialCard-module__no-margin___RqLjx",
  "editorialCard": "editorialCard-module__editorialCard___-Mrlo",
  "editorialCardMedia": "editorialCard-module__editorialCardMedia___dAoGO",
  "editorialCardImage": "editorialCard-module__editorialCardImage___7nzYL",
  "editorialCardIcon": "editorialCard-module__editorialCardIcon___f-zru",
  "editorialCardContent": "editorialCard-module__editorialCardContent___9A3kR",
  "editorialCardText": "editorialCard-module__editorialCardText___8xQHN",
  "editorialCardLink": "editorialCard-module__editorialCardLink___-D5bs",
  "editorialCard-layout-horizontal": "editorialCard-module__editorialCard-layout-horizontal___Eeo-2",
  "editorialCard-layout-vertical": "editorialCard-module__editorialCard-layout-vertical___0jBTl"
};